angular.module('impactx.MenuDirectives').service('ShutdownService', [
    '$rootScope',
    ShutdownService]);

function ShutdownService($rootScope) {

    const self = this;
    this.shutdownMessage = null;
    this.shutdownMessageSeen = false;

    this.setShutdownMessage = function (shutdownMessage) {
        if (!self.shutdownMessage && shutdownMessage) {
            $rootScope.$on('logoutSuccess', function () {
                self.setShutdownMessageSeen(false);
                self.shutdownMessage = null;
            });
            self.shutdownMessage = shutdownMessage;
        }
        else if (self.shutdownMessage && shutdownMessage && self.shutdownMessage !== shutdownMessage) {
            self.setShutdownMessageSeen(false);
            self.shutdownMessage = shutdownMessage;
        }
        else if (self.shutdownMessage && !shutdownMessage) {
            self.setShutdownMessageSeen(false);
            self.shutdownMessage = null;
        }
    };

    this.getShutdownMessage = function () {
        return self.shutdownMessage;
    };

    this.setShutdownMessageSeen = function (value) {
        self.shutdownMessageSeen = value;
    };

    this.getShutdownMessageSeen = function () {
        return self.shutdownMessageSeen;
    };

    this.hideShutdownMessage = function () {
        return self.setShutdownMessageSeen(true);
    };

    return {
        setShutdownMessage: this.setShutdownMessage,
        getShutdownMessage: this.getShutdownMessage,
        setShutdownMessageSeen: this.setShutdownMessageSeen,
        getShutdownMessageSeen: this.getShutdownMessageSeen,
        hideShutdownMessage: this.hideShutdownMessage
    };
}